/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Snapshot_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic Snapshot Settings" |
*
* @param {Options_Backup_Snapshot_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_snapshot_title = /** @type {((inputs?: Options_Backup_Snapshot_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Snapshot_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres des instantanés automatiques")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für automatische Schnappschüsse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni automatiche degli snapshot")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки автоматического создания снимков")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración automática de instantáneas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动快照设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動スナップショット設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित स्नैपशॉट सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações automáticas de captura de instantâneos")
	return /** @type {LocalizedString} */ ("Automatic Snapshot Settings")
});